export default "__VITE_ASSET__DlAbps_Z__"